import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocalizedDataSelector, useTranslate } from '@hooks';
import { fetchMarketplaceMediaCategories } from '@actions';
import { sortBy } from 'lodash';
import { Input } from '@dotone/react-ui-core';

const MarketplaceMediaCategorySelect = ({ regions = [], categoryGroupIds = [], ...otherProps }) => {
  const dispatch = useDispatch();
  const { locale } = useTranslate();
  const data = useLocalizedDataSelector(
    ({ marketplaceMediaCategoryList }) => marketplaceMediaCategoryList
  );

  const options = [];

  sortBy(data, ['displayOrder']).forEach((mediaCategory) => {
    const childOptions = sortBy(mediaCategory.childCategories, ['displayOrder']).map(
      (category) => ({
        label: category.name,
        value: category.id,
      })
    );
    options.push({
      label: mediaCategory.name,
      options: childOptions,
    });
  });

  useEffect(() => {
    if (regions.length && categoryGroupIds.length) {
      dispatch(fetchMarketplaceMediaCategories(locale, { regions, categoryGroupIds }));
    }
  }, [dispatch, locale, regions, categoryGroupIds]);

  return <Input type="select" grouped options={options} {...otherProps} />;
};

export default MarketplaceMediaCategorySelect;
